// removed by extract-text-webpack-plugin
module.exports = {"component":"Main__component___2_giO","wrapper":"Main__wrapper___1Ne0J","title":"Main__title___8caeb","text":"Main__text___cs6Ae"};


//////////////////
// WEBPACK FOOTER
// ./src/homepage/components/Main.css
// module id = 425
// module chunks = 0